export default {
    invoice_title:        "Platba na fakturu",
    invoice_info:         "Fakturu za služby PREMIUM na celý rok v hodnotě 51,60 € ti pošleme e-mailem :)",
    invoice_info_pretlak: "Fakturu za služby PREMIUM na celý rok v hodnotě 51,60 € (po slevě 43,90 €) ti pošleme e-mailem :)",
    billing_title:        "Fakturační údaje",
    billing_note:         "Fakturu ti vystavíme na tyto údaje. Pokud nemáš IČO, zadej své trvalé bydliště.",
    company_type:         "Jsem firma, živnostník",
    personal_type:        "Jsem fyzická osoba",
    company_placeholder:  "Název společnosti",
    company_label:        "Název společnosti",
    ico_placeholder:      "IČO",
    ico_label:            "IČO",
    dic_placeholder:      "DIČ",
    dic_label:            "DIČ",
    icdph_placeholder:    "IČ DPH",
    icdph_label:          "IČ DPH",
    address_placeholder:  "Ulice a číslo",
    address_label:        "Ulice a číslo",
    psc_placeholder:      "PSČ",
    psc_label:            "PSČ",
    promo_placeholder:    "PROMO KÓD",
    promo_label:          "PROMO KÓD",
    terms_agree:          "Souhlasím s",
    terms_link:           "všeobecnými obchodními podmínkami",
    order_btn:            "Objednat s povinností platby",
    company_type_value:   "Firma / živnostník",
    personal_type_value:  "Fyzická osoba",

    // ThePayment
    payment_title:          "Platit můžeš a nemusíš, je to na tobě",
    payment_subtitle:       "Pokud ti nestačí FREE verze DOFFERO, můžeš přejít na PREMIUM.",
    payment_premium_hint:   "Vyplň údaje níže a můžeš okamžitě začít vytvářet cenové nabídky v módu PREMIUM.",
    payment_leaving_title:  "Odcházíš? :(",
    payment_leaving_hint:   "To nás mrzí. Prosím dej nám vědět důvod, abychom se mohli zlepšovat.",

    // PaymentThree
    p3_success:             "Skvělé! Od teď si můžeš vychutnávat všechny výhody balíčku PREMIUM.",
    p3_downgraded:          "Tvůj balíček byl změněn na DOFFERO FREE.",
    p3_invoice:             "Fakturu za roční balíček PREMIUM ti pošleme na e-mail. Děkujeme za brzkou úhradu.",
    p3_go_offers:           "Přejít na moje nabídky",

    // PaymentFour
    p4_reason_label:        "Jaký je důvod zrušení DOFFERO PREMIUM?",
    p4_warning:             'Po kliknutí na tlačítko "ZRUŠIT" níže Vám bude okamžitě změněn balíček na DOFFERO FREE.',
    p4_back_btn:            "Zpět na balíčky",
    p4_cancel_btn:          "Zrušit DOFFERO PREMIUM",
};